import API from 'api.js';
import NetworkManager from './MockOperations/NetworkManager';
import { toast } from 'react-toastify';

/**
 * Load full mock data.
 */
// const loadFullMockApi = async (id, pending, navigate) => {
// 	try {
// 		const data = await API({
// 			method: 'GET',
// 			url: `web/question/detail/${id}/${pending}`
// 		});
// 		if ('code' in data.data && data.data.code === 'F') {
// 			navigate("/admin/unauthorized");
// 			return null;
// 		}
// 		return data.data;
// 	} catch (err) {
// 		return null;
// 	}
// };

const loadFullMockApi = async (id, pending, navigate) => {
  try {
    const data = await API({
      method: 'GET',
      url: `web/question/detail/${id}/${pending}`,
    });
    
    if ('code' in data.data && data.data.code === 'F') {
      navigate("/admin/unauthorized");
      return null;
    }
    
    return data.data;
  } catch (err) {
    if (err.code === 'ECONNABORTED') {
      console.log("API Request Timeout - Mock data loading failed");
      toast.error("Request timeout. Please check your connection and try again.");
    } else if (!err.response) {
      console.log("Network Error - No response from server");
      toast.error("Network error. Please check your internet connection.");
    } else {
      console.log("API Error:", err.response?.status);
    }
    return null;
  }
};

/**
 * Submit mock Question.
 */
// const submitMockQuestionApi = async (formData) => {
// 	return await API({
// 		method: 'POST',
// 		url: `submit/mock`,
// 		data: formData
// 	}).then(data => {
// 		return data;
// 	}).catch(err => {
// 		return false;
// 	});
// };

const submitMockQuestionApi = async (formData) => {
  try {
    return await NetworkManager.submitWithRetry({
      method: 'POST',
      url: 'submit/mock',
      data: formData
    });
  } catch (error) {
    console.error("Submit mock question failed:", error);
    return false;
  }
};


/**
 * Save & Exit Api.
 */
// const saveAndExitApi = (formData) => {
// 	API({
// 		method: 'POST',
// 		url: `submit/mock`,
// 		data: formData
// 	});
// };

const saveAndExitApi = async (formData) => {
  try {
    await NetworkManager.submitWithRetry({
      method: 'POST',
      url: 'submit/mock',
      data: formData
    });
  } catch (error) {
    console.error("Save and exit failed:", error);
  }
};


/**
 * TimeOut Api.
 */
// const sectionTimeOutApi = (formData) => {
// 	API({
// 		method: 'Post',
// 		url: 'set/mockTime',
// 		data: formData
// 	});
// };

const sectionTimeOutApi = async (formData) => {
  try {
    await NetworkManager.submitWithRetry({
      method: 'POST',
      url: 'set/mockTime',
      data: formData
    });
  } catch (error) {
    console.error("Section timeout failed:", error);
  }
};

export default loadFullMockApi;
export {
	submitMockQuestionApi,
	saveAndExitApi,
	sectionTimeOutApi
};